<template>
  <div class="question">
    <ArrangeComponents
        v-if="question.type === 'arrange'"
        :question="question.question"
        :index="index"
        :options="question.answers"
        :hint="question.small"
        @answered="answered"
    />
    <TextQuestion
      v-else-if="question.type === 'text' || question.type === 'email'"
      :inputType="question.type"
      :question="question.question"
      :hint="question.small"
      :minLength="question.minLength"
      :index="index"
      @answered="answered"
    />

    <ListQuestion
      v-else-if="question.type === 'single' || question.type === 'multiple'"
      :inputType="question.type"
      :options="question.answers"
      :question="question.question"
      :index="index"
      :slide="slide"
      @answered="answered"
    />

    <div class="submit" v-else-if="question.type === 'submit'">
      <h2>{{ question.question ? question.question : 'The world needs more people like you!!' }}</h2>
      <button class="btn btn-primary" @click="$emit('submitForm')">
         {{ question.button ? question.button : 'Submit' }}
      </button>
    </div>
  </div>
</template>

<script>
import TextQuestion from "./TextQuestion";
import ListQuestion from "./ListQuestion";
import ArrangeComponents from "./BlockQuestion";
export default {
  name: "Question",
  props: ["question", "index", "slide"],
  // components: {TextQuestion},
  components: {
    TextQuestion,
    ListQuestion,
    ArrangeComponents,
  },
  methods: {
    answered(val) {
      this.$emit("answered", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.submit {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-weight: normal;
    font-size: 32px;
    line-height: 44px;
    text-align: center;
    color: #52595e;
    margin-bottom: 44px;
  }
  .btn {
    box-shadow: none;
    border-radius: 32px;
    text-transform: capitalize;
    letter-spacing: 1px;
    padding: 10px 25px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #ffffff;
    &:hover {
      background: #557efb;
      box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
    }
    &::after,
    &::before {
      content: none;
    }
  }
}
</style>
